module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Boeckten-01bca492cd6a4c910fad891182ec3511.svg";